/**
 * @description
 * @type {RTCConfiguration} 
 */
export const RTCConfig = {
    iceServers: [
        {
            urls: 'stun:voip.grocloud.id:3478' 
        },
        {
            urls: 'turn:voip.grocloud.id:5349',
            username: 'gorst',
            credential: 'hero'
        },
    ]
}